
var PhotoSwipe = require("photoswipe/dist/photoswipe.min.js");
var PhotoSwipeUI_Default = require("photoswipe/dist/photoswipe-ui-default.min.js");

module.exports = {
    runGallery: runGallery
}

function runGallery(){
    var owl = $('.owl-carousel');
    var fixOwlCarousel = function(){
        var stage = $('.owl-stage');
        stage.width(stage.width() * 4);
    }
    owl.owlCarousel({
        items:2,
        loop: false, //$(".owl-carousel .item").length > 1 ? true : false,
        nav:false,
        dots:false,
        autoWidth:true,
        lazyLoad:true,
        margin:20,
        onInitialized: fixOwlCarousel,
        onRefreshed: fixOwlCarousel,
        responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            1000:{
                items:3
            },
            1600:{
                items:4
            }
        }
    }).trigger('refresh.owl.carousel');

    var openPhotoSwipe = function(startIndex) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        /*build items array*/
        var items = [];

        $(".owl-carousel .owl-item:not(.cloned) img").each(function(){

            var rate = 0;

            if($(this).height() && $(this).width() &&
                parseInt($(this).height()) > 0 &&
                parseInt($(this).width()) > 0) {
                rate = parseInt($(this).height()) / parseInt($(this).width());
            }

            var width = 0;
            if($(this).attr("data-size")) {
                width = parseInt($(this).attr("data-size"));
            }

            var height = parseInt(width) * rate;

            if($(this).attr("data-src") && width > 0 && height > 0) {
                var copyright = $(this).prev(".carousel--img-caption-copyright").html() ? $(this).prev(".carousel--img-caption-copyright").html() : "";
                var image = {
                    src: $(this).attr("data-src"),
                    h: parseInt(height) ,
                    w: parseInt(width),
                    title: $(this).next(".carousel--img-caption").html() +" "+ copyright
                };

                items.push(image);
            }
        });

        /*define options (if needed)*/
        var options = {
            /*history & focus options are disabled on CodePen*/
            history: false,
            focus: false,
            showAnimationDuration: 0,
            hideAnimationDuration: 0,
            index: startIndex ? startIndex : 0
        };

        var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    $("#viewGallery").on("click",function(){
        openPhotoSwipe(0)
    })
    $(".owl-item").on("click", function(){
        openPhotoSwipe($(this).parent().children(".owl-item:not(.cloned)").index($(this)));
    });
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/gallery.js